import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCreateLevel } from "../api/queries";
import { LevelForm } from "../ui/levels/LevelForm";

export function LevelCreatePage() {
  const nav = useNavigate({ from: "/app/master/levels/create" });
  const createLevel = useCreateLevel();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ລະດັບ", to: "/app/master/levels" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງລະດັບ
            </h2>
            <p className="text-muted-foreground">ສ້າງລະດັບໃໝ່ໃນລະບົບ.</p>
          </div>

          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/master/levels" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <div className="mt-6 rounded-xl border bg-card p-6">
          <LevelForm
            onSubmit={async (vals) => {
              try {
                await createLevel.mutateAsync(vals);
                nav({ to: "/app/master/levels" });
              } catch (error) {
                // Error handling is done by the mutation
              }
            }}
            submitting={createLevel.isPending}
          />
        </div>
      </Main>
    </>
  );
}
